<template>
  <div>
    {{ remainingCount }}
  </div>
</template>

<script>
export default {
  props: {
    remainingCount: {
      type: Number,
      default() {
        return 1;
      },
      required: true,
    },
    count: {
      type: Number,
      default() {
        return 1;
      },
      required: false,
    },
  },
};
</script>
